<template>
  <div id="dataStatistics">
    <div class="amountOfStatistical">
      <h1 class="bgImg">使用数据</h1>
      <div class="scroll-div" id="amountOfStatistical">
        <div class="">
          <!-- <div class="icon-arrow-left pointer"
            @click="scrollLeft('amountOfStatistical')">
            <i class="el-icon-arrow-left"></i>
          </div> -->
          <el-row class="el-row-order">
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="iconImg"><img src="../../assets/img/icon10.png" alt=""></div>
                <div class="conem">
                  <div class="jisaeg">卡板总数</div>
                  <div class="monery">{{dataStatistics.totalSim }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="iconImg"><img src="../../assets/img/icon07.png" alt=""></div>
                <div class="conem">
                  <div class="jisaeg">已激活数</div>
                  <div class="monery">{{ dataStatistics.actived }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="iconImg"><img src="../../assets/img/icon05.png" alt=""></div>
                <div class="conem">
                  <div class="jisaeg">本月激活</div>
                  <div class="monery">{{ dataStatistics.activing }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="iconImg"><img src="../../assets/img/icon02.png" alt=""></div>
                <div class="conem">
                  <div class="jisaeg">总充值额</div>
                  <div class="monery">{{ money_format(dataStatistics.totalInvent, 0) }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="iconImg"><img src="../../assets/img/icon04.png" alt=""></div>
                <div class="conem">
                  <div class="jisaeg">总消费额</div>
                  <div class="monery">{{ money_format(dataStatistics.totalUsePrice, 0) }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="iconImg"><img src="../../assets/img/icon06.png" alt=""></div>
                <div class="conem">
                  <div class="jisaeg">本月消费额</div>
                  <div class="monery">{{ money_format(dataStatistics.monthUsePrice, 0) }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="iconImg"><img src="../../assets/img/icon10.png" alt=""></div>
                <div class="conem">
                  <div class="jisaeg">总池组数</div>
                  <div class="monery">{{ dataStatistics.totalPool }}</div>
                </div>
              </div>
            </el-col>
            
            <el-col :span="3">
              <div class="grid-content bg-purple">
                <div class="iconImg"><img src="../../assets/img/icon08.png" alt=""></div>
                <div class="conem">
                  <div class="jisaeg">欠费池组数</div>
                  <div class="monery">{{ dataStatistics.fuPool }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- <div class="icon-arrow-right pointer" v-show="statisticScrollRightShow"
            @click="scrollRight('amountOfStatistical')">
            <i class="el-icon-arrow-right"></i>
          </div> -->
        </div>
      </div>

    </div>
    <!--激活排行榜-->
    <h1 class="bgImg" style="margin:10px 0;">年度消费统计</h1>
    <div style="width: 100%;height:320px;" >
      <linEchart :data="echartsData"/>
    </div>

    <h1 class="bgImg" style="margin:10px 0;">当月消费T O P</h1>
     <!--当月用量排行榜-->
     <div style="width: 100%;height:320px;" >
      <barEacher1 :data="echartsData2"/>
    </div>

    <h1 class="bgImg" style="margin:10px 0;">池组卡板T O P</h1>
    <!--激活排行榜-->
    <div style="width: 100%;height:320px;" >
      <barEacher :data="echartsData1"/>
    </div>
   
    <!--  卡片统计  -->
    <div class="amountOfStatistical" style="height: auto;">
      <h1 class="bgImg" style="margin:10px 0;"> 池组统计</h1>
      <el-row class="row-item">
        <el-col :span="12" v-for="item in cardStatistics" :key="item.key">
          <div class="grid-content bg-purple">
            <div class='title-left'>{{ item.poolName }}</div>
            <el-row class="row-flex">
              <el-col :span="3">
                <div class="totleName">总数量</div>
                <div class="totleNum">{{ number_format(item.totalSim, 0) }}</div>
              </el-col>
              <el-col :span="3">
                <div class="totleName">激活过</div>
                <div class="totleNum">{{ number_format(item.activedSim, 0) }}</div>
              </el-col>
              <el-col :span="3">
                <div class="totleName">本月在用</div>
                <div class="totleNum">{{ number_format(item.activingSim, 0) }}</div>
              </el-col>
              <el-col :span="3">
                <div class="totleName">总充值额</div>
                <div class="totleNum">{{ number_format(item.totalPrice, 0) }}</div>
              </el-col>
              <el-col :span="3">
                <div class="totleName">总使用量(G)</div>
                <div class="totleNum">{{ number_format(item.totalData, 0) }}</div>
              </el-col>
              <el-col :span="3">
                <div class="totleName">本月消费</div>
                <div class="totleNum">{{ number_format(item.monthPrice, 0) }}</div>
              </el-col>
              <el-col :span="3">
                <div class="totleName">本月用量(G)</div>
                <div class="totleNum">{{ number_format(item.monthData, 0) }}</div>
              </el-col>
              <el-col :span="3">
                <div class="totleName">池组余额</div>
                <div class="totleNum">{{ number_format(item.remainPrice, 0) }}</div>
              </el-col>
             
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>
<script>
import common from '@/utils/common.js'
import linEchart from './linEchart.vue'
import barEacher from './barEacher.vue'
import barEacher1 from './barEacher1.vue'

export default {
  components:{
    linEchart,
    barEacher,
    barEacher1
  },
  data() {
    return {
      dataStatistics: {

      },
      echartsData:{   //波浪图
        xData:[],
        yData:[{},{}],
      },
      echartsData1:{ //激活排行榜
        xData:[],
        yData:[{},{},{}],
      },
      echartsData2:{ //当月用量排行榜
        xData:[],
        yData:[{},{},{}],
      },
      cardStatistics: [],

    }
  },
  methods: {



  },

  created() {
    this.echartsData={   //波浪图
      xData:[],
      yData:[{data:[], name:"使用量GB", type: 'line',},{data:[],name:"消费金额(元)",  type: 'line',}],
    },
    this.echartsData1={ //激活排行榜
      xData:[],
      yData:[{data:[],  name:"总卡数",type: 'bar',barWidth: '20px'},{data:[],  name:"已激活",type: 'bar',barWidth: '20px'},{data:[],name:"本月在用",  type: 'bar',barWidth: '20px'}],
    },
    this.echartsData2={ //当月用量排行榜
      xData:[],
      yData:[{data:[],name:"使用量GB",  type: 'bar',barWidth: '20px'},{data:[], name:"消费金额", type: 'bar',barWidth: '20px'}],
    },
    common.sysRequest('pool/select/pool/count', {}, 'post').then(res => {
        this.dataStatistics=res.data.data;
        this.cardStatistics=res.data.data.poolList;
        if(Array.isArray(res.data.data.monthList) && res.data.data.monthList.length > 0){
          res.data.data.monthList.sort((b,a) => new Date(b.month).getTime() - new Date(a.month).getTime()).forEach(item=>{
            this.echartsData.xData.push(item.month)
            this.echartsData.yData[0].data.push(item.allData)
            this.echartsData.yData[1].data.push(item.totalAmount)
          })
        }
        if(Array.isArray(res.data.data.poolList) && res.data.data.poolList.length > 0){
          res.data.data.poolList.sort((b,a) => b.totalSim - a.totalSim).forEach((item,index)=>{
            if(index < 7){
              this.echartsData1.xData.push(item.poolName)
              this.echartsData1.yData[0].data.push(item.totalSim || 0)
              this.echartsData1.yData[1].data.push(item.activedSim || 0)
              // this.echartsData1.yData[index].name = res.data.data.poolList[index].poolName
              this.echartsData1.yData[2].data.push(item.activingSim || 0)
            }
          })
          res.data.data.poolList.sort((b,a) => b.monthData - a.monthData).forEach((item,index)=>{
            if(index < 7){
              this.echartsData2.xData.push(item.poolName)
              this.echartsData2.yData[0].data.push(item.monthData || 0)
              // this.echartsData2.yData[index].name = res.data.data.poolList[index].poolName
              this.echartsData2.yData[0].data.push(item.monthData || 0)
              this.echartsData2.yData[1].data.push(item.monthPrice || 0)
            }
          })
          console.log(this.echartsData1)
        }
    })
  },

  updated() {

  },

  watch: {

  },
}
</script>  
<style lang="less" scoped>
.row-item {
  .el-col-12 {
    padding: 10px;

    ::v-deep .grid-content {
      background: #FFFFFF;
      border-radius: 8px;

      .title-left {
        background: #E6ECF6;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        color: #19213F;
        text-align: center;
        font-size: 14px;
        height: 40px;
        font-weight: bold;
        line-height: 40px;
      }

      .row-flex {
        height: 100px;

        .el-col-8 {
          text-align: center;
        }

        .totleName {
          margin-top: 20px;
          color: #636C88;
          font-size: 14px;
          text-align: center;
          margin-bottom: 10px;
        }

        .totleNum {
          color: #19213F;
          font-size: 16px;
          text-align: center;
        }
      }
    }
  }
}

.el-row-order {
  .el-col-3 {
    padding: 10px;
    height: 110px;

    ::v-deep .grid-content {
      background: #FFFFFF;
      border-radius: 8px;
      display: flex;
      height: 100%;
      align-items: center;

      .iconImg {
        width: 46px;
        height: 46px;
        margin-left: 10px;

        img {
          width: 46px;
          height: 46px;
        }
      }

      .conem {
        margin-left: 10px;

        .jisaeg {
          color: #636C88;
          font-size: 14px;
          margin-bottom: 5px;
        }

        .monery {
          color: #19213F;
          font-size: 20px;
        }
      }
    }
  }
}

::v-deep .el-tabs--border-card {
  background: #F3F5F9;
}

h1.bgImg {
  // background: url(./../../assets/icon5.png) no-repeat left center;
  // padding-left:36px;
  font-size: 16px;
  color: #19213F;
  font-weight: bold;
  margin-bottom: 10px;
}

#dataStatistics {

  .amountOfStatistical {
    /deep/ h1 {
      font-size: 16px;
      line-height: 22px;
    }

    .scroll-div {
      padding: 10px;
      // background: #fff;

      .tag-defined {
        min-height: 110px;
        display: flex;
        justify-content: space-between;


        .amountOfStatisticalItem {
          flex: 1;
          padding-left: 80px;

          >div {
            box-sizing: border-box;
            max-width: 300px;
            min-width: 160px;
            height: 110px;
            transition: .5s;
            border-radius: 10px;
            color: #fff;

            h1 {
              font-size: 20px;
            }

            h2 {
              font-size: 15px;
            }



            .amountOfStatisticalItem-left {
              display: inline-block;
              width: 5px;
              height: 100%;
              float: left;
              border-radius: 4px 0 0 4px;
            }

            .amountOfStatisticalItem-right {
              display: inline-block;
              height: 100%;
              margin-left: 20px;

              h2 {
                margin-top: 15px;
              }

              h2,
              p {
                margin-bottom: 10px;
              }
            }

          }
        }

        .amountOfStatisticalItem:last-child {
          padding-right: 0px;
        }

      }

    }



    .cardStatisticalItem {
      display: flex;
      flex-basis: 23%;
      box-sizing: border-box;
      height: 120px;
      color: #424242;
      background: #fff;
      transition: .5s;
      border-radius: 16px;

      .title-left {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 65px;
        background: #6196FC;
        color: #fff;
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;

        h1 {
          width: 20px;
          margin: 0 auto;
          font-size: 16px;
          line-height: 20px;
          word-wrap: break-word;
          /*英文的时候需要加上这句，自动换行*/
          text-align: center;
        }
      }



      .content-right {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;

        h1 {
          width: 100%;
          font-size: 20px;

          span {
            display: inline-block;
            text-align: center;
            width: 90px;
            font-size: 14px;
            color: #999;
          }
        }
      }
    }

  }



  .icon-arrow-left,
  .icon-arrow-right {
    display: inline-block;
    width: 30px;
    line-height: 100px;
    vertical-align: top;
    font-size: 26px;
    text-align: center;
    transition: .5s;
    z-index: 100;
  }

  .icon-arrow-left:hover,
  .icon-arrow-right:hover {
    color: #409eff;
    transition: .3s;
  }

  .icon-arrow-left {
    position: absolute;
    left: 0;
    box-shadow: 10px 0px 10px #fff;
    background: #fff;
  }

  .icon-arrow-right {
    position: absolute;
    right: 0;
    box-shadow: -10px 0px 10px #fff;
    background: #fff;
  }

  .pointer {
    cursor: pointer;
  }






  .more-flux {
    overflow-y: hidden;
    height: 350px;

    .scroll-div {
      overflow-x: scroll;

      .tag-defined {
        min-height: 350px;
        display: flex;
        justify-content: space-between;


        .item {
          width: 350px;
          height: 330px;
          border: 1px solid #e4e7ed;
          margin-right: 10px;

          h3 {
            display: flex;
            justify-content: space-between;
            font-size: 16px;
            padding: 10px;
            border-bottom: 1px solid #e4e7ed;

            span {
              padding-left: 6px;
              border-left: 4px solid #409eff;
            }
          }

          .info {
            display: flex;
            justify-content: space-around;
            line-height: 2em;

            div {
              text-align: center;

              span {
                color: #409eff;
              }
            }
          }

          .ul_content {
            margin-top: 4px;
            margin-left: 10px;
            font-size: 16px;

            li {
              padding-top: 4px;
            }
          }
        }
      }
    }
  }

  .content {
    margin-bottom: 10px;

    .item {
      margin: 0 10px;
      background: #fff;
      border-radius: 16px;

      h3 {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        padding: 10px;
        border-bottom: 1px solid #e4e7ed;

        span {
          padding-left: 6px;
          border-left: 4px solid #409eff;
        }
      }

      .info {
        display: flex;
        justify-content: space-around;
        line-height: 2em;

        div {
          text-align: center;

          span {
            color: #409eff;
          }
        }
      }

      .ul_content {
        margin-top: 4px;
        margin-left: 10px;
        font-size: 16px;

        li {
          padding-top: 4px;
        }
      }
    }
  }
}
</style>